
import React, { useState } from 'react';
import { useContactForm } from '../../hooks/useContactForm';
import styles from '../../styles/ContactUs.module.css';
import { useNoSidebar } from '../../hooks/useNoSidebar';

const faqs = [
	{
		question: 'What is Realty Genie?',
		answer: 'Realty Genie is a comprehensive real estate management platform designed to streamline documentation and compliance management.'
	},
	{
		question: 'What services does Realty Genie offer?',
		answer: 'The Realty Genie platform leverages industry knowledge to easily lay out all the documentation and compliance requirements.'
	},
	{
		question: 'What is included in the service?',
		answer: 'We offer a documentation and listing management hubs, as well as an in-house educational platform.'
	},
	{
		question: 'How do I contact support?',
		answer: 'Use the contact form on this page or email help@realty-genie.co.za'
	}
];

const ContactUs: React.FC = () => {
	useNoSidebar();
	const [form, setForm] = useState({
		name: '',
		surname: '',
		email: ''
	});
	const { submitContactForm, submitting, submitted, error } = useContactForm();

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		
		// Client-side validation
		if (!form.name || !form.surname || !form.email || !(e.target as HTMLFormElement).message.value) {
			return;
		}
		if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) {
			return;
		}
		
		const result = await submitContactForm({
			name: form.name,
			surname: form.surname,
			email: form.email,
			message: (e.target as HTMLFormElement).message.value
		});
		
		if (result.success) {
			// Reset form
			setForm({ name: '', surname: '', email: '' });
			(e.target as HTMLFormElement).message.value = '';
		}
	};

	return (
		<div className={styles['contactus-container']}>
			<section className={styles['faqs-section']}>
				<div className={styles['faqs-title']}>Frequently Asked Questions</div>
				{faqs.map((faq, idx) => (
					<div key={idx} className={styles['faq-item']}>
						<div className={styles['faq-question']}>{faq.question}</div>
						<div className={styles['faq-answer']}>{faq.answer}</div>
					</div>
				))}
			</section>
			<section className={styles['contact-form-section']}>
				<div className={styles['contact-form-title']}>Contact Us</div>
				{submitted ? (
					<div className={styles['success-message']}>
						Thank you for contacting us! We'll get back to you soon.
					</div>
				) : (
					<form onSubmit={handleSubmit} className={styles['contact-form']}>
						<div className={styles['form-row']}>
							<label htmlFor="name" className={styles['form-label']}>Name:</label>
							<input
								id="name"
								type="text"
								name="name"
								value={form.name}
								onChange={handleChange}
								className={styles['form-input']}
								required
							/>
						</div>
						<div className={styles['form-row']}>
							<label htmlFor="surname" className={styles['form-label']}>Surname:</label>
							<input
								id="surname"
								type="text"
								name="surname"
								value={form.surname}
								onChange={handleChange}
								className={styles['form-input']}
								required
							/>
						</div>
						<div className={styles['form-row']}>
							<label htmlFor="email" className={styles['form-label']}>Email:</label>
							<input
								id="email"
								type="email"
								name="email"
								value={form.email}
								onChange={handleChange}
								className={styles['form-input']}
								required
							/>
						</div>
						<div className={styles['textarea-row']}>
							<label htmlFor="message" className={styles['form-label']}>Message:</label>
							<textarea
								id="message"
								name="message"
								defaultValue=""
								className={styles['form-textarea']}
								required
								rows={5}
							/>
						</div>
						{error && <div className={styles['error-message']}>{error}</div>}
						<button type="submit" disabled={submitting} className={styles['submit-button']}>
							{submitting ? 'Sending...' : 'Send Message'}
						</button>
					</form>
				)}
			</section>
		</div>
	);
};

export default ContactUs;
